import React from "react";
import { Drawer } from "@mui/material";
import { APP_LOC_KEY_FUNCTION, JcAppLocation } from "./JcAppLocation";
import { JcCommonProps, JcUtils } from "../../utils/JcUtils";
import { JcColumn } from "../JcBox";
import { JcList } from "../JcList";
import { JcSeparator } from "../JcSeparator";
import { JcAppTitleText } from "./JcAppTitleText";

export interface JcAppDrawerProps<KeyT extends string> extends JcCommonProps {
    readonly location: JcAppLocation<KeyT>;
    readonly appTitle: string;
    readonly navigateHome: () => void;
    readonly open: boolean;
    readonly onClose: () => void;
    readonly locations: ReadonlyArray<JcAppLocation<KeyT>>;
}

export const JcAppDrawer = <KeyT extends string>(props: JcAppDrawerProps<KeyT>): React.ReactElement => {
    const commonProps = JcUtils.commonProps(props, ["jc-app-navigation-drawer"])
    return <Drawer anchor="right"
        open={props.open}
        onClose={props.onClose}>
        <JcColumn {...commonProps}>
            <JcAppTitleText className="jc-app-drawer-title"
                label={props.appTitle}
                onNavigate={props.navigateHome} />
            <JcSeparator />
            <JcList keyFunction={APP_LOC_KEY_FUNCTION}
                noBorder
                items={props.locations}
                selection={props.locations.find(loc => loc.key === props.location.key)}
                onSelection={location => location.onNavigate()}
                itemRenderer={location => location.label} />
        </JcColumn>
    </Drawer>;
}